module.exports = __webpack_public_path__ + "img/gish_bus_mungun.a620d7d1.svg";